import { useSectionContent } from "./useSectionContent";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, HeartHandshake, Activity, TreePine, MapPin, BookOpen, Sparkles, Users, ShieldCheck, Wind } from "lucide-react";
import api from "@/lib/api";
import CountUp from "@/components/motion/CountUp";
import { useSite } from "@/contexts/SiteContext";
import { useAuth } from "@/contexts/AuthContext";


/* Secțiuni noi de homepage (Dim 15). Fiecare e o secțiune CMS (visible din live editor). */


/* ── 15.30 De ce o pădure? ── */
export function HomeWhyForest() {
  const c = useSectionContent("home_why_forest");
  return (
    <section className="py-16 lg:py-20" style={{ background: "var(--ct-bg)" }}>
      <div className="max-w-2xl mx-auto px-5 text-center">
        <TreePine size={30} className="mx-auto mb-4" style={{ color: "var(--ct-link)" }} />
        <span data-el="eyebrow" data-field="eyebrow" className="eyebrow">{c.eyebrow || "De ce o pădure?"}</span>
        <h2 data-el="title" data-field="title" className="font-serif text-3xl sm:text-4xl mt-3 mb-5">{c.title || "Vindecarea e ca un copac"}</h2>
        <p data-el="body" data-field="body" className="text-base leading-relaxed" style={{ color: "var(--ct-text-muted)" }}>
          {c.body || (<>
            E invizibilă și lentă — nu o vezi crescând de la o zi la alta. Dar crește. Are anotimpuri:
            și zile de înflorire, și ierni de odihnă. Și, cel mai important — <strong style={{ color: "var(--ct-text)" }}>nu moare
            la o singură zi grea</strong>. Aici, o facem vizibilă: fiecare pas al tău hrănește un copac care e doar al tău,
            într-o pădure de oameni care merg pe același drum.
          </>)}
        </p>
      </div>
    </section>
  );
}
